import {inject} from 'aurelia-framework';
import {Router} from "aurelia-router";
import Backend from "./backend";
import {EventAggregator} from "aurelia-event-aggregator";

@inject(Router, Backend, EventAggregator)
export class NavBar {
  router;
  backend;
  eventAggregator;

  sidebarViewModel;

  constructor(router, backend, eventAggregator) {
    this.router = router;
    this.backend = backend;
    this.eventAggregator = eventAggregator;

    this.eventAggregator.subscribe('ProblemCountChanged', (event) => {
      this.bind();
    });

    // Close side nav after navigation.
    // This is done because the UX feels more intuitive.
    // Also: after navigating to order-index the menu can't be removed properly for some reason, this happens to circumvent that bug.
    let self = this;
    this.router.pipelineProvider.addStep('postRender', {
      run(navigationInstruction, next) {
        // Media query lifted from the css that hides sidenav on narrow screens.
        let isSidenavCollapsible = window.matchMedia("only screen and (max-width: 992px)");
        if (isSidenavCollapsible.matches) {
          if (self.sidebarViewModel) {
            self.sidebarViewModel.hide();
          }
        }
        return next();
      }
    });
  }

  bind() {
    this.backend.ProblemListQueryHandler_unResolvedProblemCount()
      .then(count => {
        this.unResolvedProblemCount = count;
        let problemListRoute = this.router.navigation.filter(nav => nav.config.name === 'problem-list')[0];
        if (problemListRoute) {
          problemListRoute.unResolvedProblemCount = this.unResolvedProblemCount;
        }
      });
  }
}
